(function () {
  'use strict';

  /* ── LOGO SCROLL ANIMATION ─────────────────────────────────────────── */
  const logoWrap = document.getElementById('logoHero');
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function lerp(a, b, t) { return a + (b - a) * t; }
  function easeInOut(t) { return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t; }

  let scrollRaf = null;

  // Shared "final / nav position" transform — used for non-homepage pages
  // and for the homepage on mobile, where the scroll-scrub animation is skipped.
  function computeNavTransform() {
    const vw = window.innerWidth;
    const vh = window.innerHeight;
    const isMobile = vw <= 768;
    const heroImgWidth = vw * (isMobile ? 0.70 : 0.30);
    const targetScale = 32 / (heroImgWidth * 0.90);
    // Nav vertical centre differs by breakpoint (nav padding-top: 28px desktop, 22px mobile)
    // 35/41 = nav's own vertical center; +32 accounts for the announcement bar above it.
    const navCenterY = isMobile ? 67 : 73;
    const topY = -(vh / 2 - navCenterY);
    return `translate(-50%, -50%) translateY(${topY}px) scale(${targetScale})`;
  }

  function updateLogo() {
    if (!logoWrap) return;
    if (prefersReducedMotion) {
      logoWrap.style.transform = 'translate(-50%, -50%)';
      return;
    }

    const isStatic = logoWrap.classList.contains('logo-static');

    // Non-homepage pages: logo is pinned at nav size/position with no
    // scroll-driven size animation.
    if (isStatic) {
      logoWrap.style.transform = computeNavTransform();
      return;
    }

    const scrollY = window.scrollY;
    const vh = window.innerHeight;
    const vw = window.innerWidth;
    const isMobile = vw <= 768;

    const rawProgress = Math.min(Math.max(scrollY / (vh * 0.5), 0), 1);
    const progress = easeInOut(rawProgress);

    // Tightly cropped logo — mark fills ~90% of image width
    const heroImgWidth = vw * (isMobile ? 0.70 : 0.225);
    const visibleMarkWidth = heroImgWidth * 0.90;
    const targetScale = 32 / visibleMarkWidth;
    const scale = lerp(1, targetScale, progress);

    // No canvas offset correction needed — logo is centred in its canvas
    // 35/41 = nav's own vertical center; +32 accounts for the announcement bar above it.
    const navCenterY = isMobile ? 67 : 73;
    const topY = -(vh / 2 - navCenterY);
    const upwardShift = lerp(0, topY, progress);

    logoWrap.style.transform =
      `translate(-50%, -50%) translateY(${upwardShift}px) scale(${scale})`;
  }

  function onScroll() {
    if (!logoWrap) return;
    logoWrap.style.willChange = 'transform';
    if (scrollRaf) cancelAnimationFrame(scrollRaf);
    scrollRaf = requestAnimationFrame(() => {
      updateLogo();
      setTimeout(() => { logoWrap.style.willChange = 'auto'; }, 200);
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', updateLogo);
  updateLogo();  // On non-homepage pages, lock logo to nav position

  /* ── NAV / LOGO COLOUR SWITCH (homepage only) ─────────────────────── */
  const heroSection = document.querySelector('.hero');

  function updateNavColour() {
    if (!heroSection) return;
    const heroBottom = heroSection.getBoundingClientRect().bottom;
    document.body.classList.toggle('hero-active', heroBottom > 0);
  }

  if (heroSection) {
    window.addEventListener('scroll', updateNavColour, { passive: true });
    updateNavColour();
  }

  /* ── HERO VIDEO: responsive source + autoplay (iOS Safari fallback) ── */
  const heroVideo = document.getElementById('heroBgVideo');
  if (heroVideo) {
    let heroIsMobileSrc = window.innerWidth <= 768;

    function setHeroVideoSrc(useMobile) {
      heroVideo.querySelectorAll('source').forEach((el) => el.remove());
      const heroSource = document.createElement('source');
      heroSource.src = useMobile ? heroVideo.dataset.mobileSrc : heroVideo.dataset.desktopSrc;
      heroSource.type = 'video/mp4';
      heroVideo.appendChild(heroSource);
      heroVideo.load();
      heroIsMobileSrc = useMobile;
    }

    setHeroVideoSrc(heroIsMobileSrc);

    /* Guards against environments where the viewport isn't settled yet at
       initial script run — corrects the source if it turns out mismatched. */
    window.addEventListener('resize', () => {
      const shouldBeMobile = window.innerWidth <= 768;
      if (shouldBeMobile !== heroIsMobileSrc) setHeroVideoSrc(shouldBeMobile);
    }, { passive: true });

    heroVideo.muted = true;
    heroVideo.defaultMuted = true;
    const tryPlay = () => heroVideo.play().catch(() => {});
    tryPlay();
    heroVideo.addEventListener('loadedmetadata', tryPlay);
    heroVideo.addEventListener('canplay', tryPlay);
    document.addEventListener('touchstart', tryPlay, { once: true, passive: true });
    window.addEventListener('scroll', tryPlay, { once: true, passive: true });
  }

  /* ── ANNOUNCEMENT BAR: opens the Klaviyo signup popup ─────────────── */
  // Fill in once the Klaviyo popup form exists (Klaviyo dashboard > form > ID).
  const KLAVIYO_SIGNUP_FORM_ID = 'WrEaXe';
  const announcementTrigger = document.getElementById('announcementSignupTrigger');
  if (announcementTrigger) {
    announcementTrigger.addEventListener('click', () => {
      if (KLAVIYO_SIGNUP_FORM_ID && window.klaviyo && typeof window.klaviyo.openForm === 'function') {
        window.klaviyo.openForm(KLAVIYO_SIGNUP_FORM_ID);
      }
    });
  }

  /* ── MENU ──────────────────────────────────────────────────────────── */
  const menuOverlay  = document.getElementById('menuOverlay');
  const menuBtn      = document.getElementById('menuBtn');
  const menuClose    = document.getElementById('menuClose');
  const menuBackdrop = document.getElementById('menuBackdrop');
  const looksPanel   = document.getElementById('looksPanel');
  const looksLinks   = document.querySelectorAll('[data-open-looks]');
  const looksBack    = document.getElementById('looksBack');
  const shopLink     = document.getElementById('shopLink');

  const searchBtn      = document.getElementById('searchBtn');
  const searchBar       = document.getElementById('searchBar');
  const searchBackdrop  = document.getElementById('searchBackdrop');
  const searchClose     = document.getElementById('searchClose');
  const searchInput     = document.getElementById('searchInput');

  let menuOpen   = false;
  let looksOpen  = false;
  let searchOpen = false;

  function updateOverlayLock() {
    const locked = menuOpen || looksOpen || searchOpen || quickaddOpen;
    document.body.classList.toggle('menu-open', menuOpen || looksOpen || searchOpen);
    document.body.style.overflow = locked ? 'hidden' : '';
  }

  function openMenu() {
    if (!menuOverlay || !menuBtn) return;
    if (searchOpen) closeSearch();
    menuOverlay.classList.add('open');
    if (menuBackdrop) menuBackdrop.classList.add('open');
    menuBtn.setAttribute('aria-expanded', 'true');
    menuOpen = true;
    updateOverlayLock();
  }

  function closeMenu() {
    if (!menuOverlay || !menuBtn) return;
    if (looksOpen) closeLooks();
    menuOverlay.classList.remove('open');
    if (menuBackdrop) menuBackdrop.classList.remove('open');
    menuBtn.setAttribute('aria-expanded', 'false');
    menuOpen = false;
    updateOverlayLock();
  }

  function openLooks() {
    if (!looksPanel) return;
    looksPanel.classList.add('open');
    looksOpen = true;
    updateOverlayLock();
  }

  function closeLooks() {
    if (!looksPanel) return;
    looksPanel.classList.remove('open');
    looksOpen = false;
    updateOverlayLock();
  }

  function openSearch() {
    if (!searchBar || !searchBtn) return;
    if (menuOpen) closeMenu();
    searchBar.classList.add('open');
    if (searchBackdrop) searchBackdrop.classList.add('open');
    searchBtn.setAttribute('aria-expanded', 'true');
    searchOpen = true;
    updateOverlayLock();
    if (searchInput) setTimeout(() => searchInput.focus(), 400);
  }

  function closeSearch() {
    if (!searchBar || !searchBtn) return;
    searchBar.classList.remove('open');
    if (searchBackdrop) searchBackdrop.classList.remove('open');
    searchBtn.setAttribute('aria-expanded', 'false');
    searchOpen = false;
    updateOverlayLock();
  }

  if (menuBtn)      menuBtn.addEventListener('click', () => menuOpen ? closeMenu() : openMenu());
  if (menuClose)    menuClose.addEventListener('click', closeMenu);
  if (menuBackdrop) menuBackdrop.addEventListener('click', closeMenu);
  looksLinks.forEach((el) => el.addEventListener('click', (e) => { e.preventDefault(); openLooks(); }));
  if (looksBack)    looksBack.addEventListener('click', closeLooks);

  if (searchBtn)      searchBtn.addEventListener('click', () => searchOpen ? closeSearch() : openSearch());
  if (searchClose)    searchClose.addEventListener('click', closeSearch);
  if (searchBackdrop) searchBackdrop.addEventListener('click', closeSearch);

  if (shopLink) {
    shopLink.addEventListener('click', closeMenu);
  }


  /* ── CART DRAWER ───────────────────────────────────────────────────── */
  const cartDrawer   = document.getElementById('cartDrawer');
  const cartBackdrop = document.getElementById('cartBackdrop');
  const cartBtn      = document.getElementById('cartBtn');
  const cartClose    = document.getElementById('cartClose');
  const cartBody     = document.getElementById('cartDrawerBody');
  const cartFooter   = document.getElementById('cartDrawerFooter');

  let cartOpen = false;

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2) + ' AUD';
  }

  function escapeHtml(str) {
    if (!str) return '';
    const div = document.createElement('div');
    div.textContent = String(str);
    return div.innerHTML;
  }

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('open');
    if (cartBackdrop) cartBackdrop.classList.add('open');
    document.body.style.overflow = 'hidden';
    cartOpen = true;
    fetchAndRenderCart();
  }

  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    if (cartBackdrop) cartBackdrop.classList.remove('open');
    if (!menuOpen) document.body.style.overflow = '';
    cartOpen = false;
  }

  async function fetchAndRenderCart() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      renderCart(cart);
    } catch (err) {
      console.error('[GU3] Cart fetch error:', err);
    }
  }

  function renderCart(cart) {
    if (!cartBody || !cartFooter) return;

    if (cart.item_count === 0) {
      cartBody.innerHTML = '<p class="cart-empty">Your cart is empty.</p>';
      cartFooter.innerHTML = '';
      return;
    }

    cartBody.innerHTML = cart.items.map(item => `
      <div class="cart-item" data-key="${escapeHtml(item.key)}">
        <div class="cart-item-image">
          ${item.image
            ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.title)}" width="72" height="96" loading="lazy">`
            : '<div class="cart-item-img-placeholder"></div>'
          }
        </div>
        <div class="cart-item-info">
          <div class="cart-item-title">${escapeHtml(item.product_title)}</div>
          ${item.variant_title && item.variant_title !== 'Default Title'
            ? `<div class="cart-item-variant">${escapeHtml(item.variant_title)}</div>`
            : ''
          }
          <div class="cart-item-price">${formatMoney(item.final_line_price)}</div>
          <div class="cart-item-qty">
            <button class="cart-qty-btn" data-key="${escapeHtml(item.key)}" data-qty="${item.quantity - 1}" aria-label="Decrease quantity">−</button>
            <span>${item.quantity}</span>
            <button class="cart-qty-btn" data-key="${escapeHtml(item.key)}" data-qty="${item.quantity + 1}" aria-label="Increase quantity">+</button>
          </div>
        </div>
        <button class="cart-item-remove" data-key="${escapeHtml(item.key)}" aria-label="Remove ${escapeHtml(item.product_title)}">×</button>
      </div>
    `).join('');

    cartFooter.innerHTML = `
      <div class="cart-total">
        <span class="cart-total-label">Total</span>
        <span class="cart-total-price">${formatMoney(cart.total_price)}</span>
      </div>
      <a href="/checkout" class="btn-checkout">Checkout</a>
      <p class="cart-note">Taxes and shipping calculated at checkout.</p>
    `;

    cartBody.querySelectorAll('.cart-qty-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        updateCartItem(btn.dataset.key, parseInt(btn.dataset.qty, 10));
      });
    });

    cartBody.querySelectorAll('.cart-item-remove').forEach(btn => {
      btn.addEventListener('click', () => {
        updateCartItem(btn.dataset.key, 0);
      });
    });
  }

  async function addToCart(variantId, quantity) {
    quantity = quantity || 1;
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.description || 'Could not add to cart');
    }
    const cart = await getCart();
    updateNavCartCount(cart.item_count);
    return cart;
  }

  async function updateCartItem(key, quantity) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      });
      const cart = await res.json();
      updateNavCartCount(cart.item_count);
      renderCart(cart);
    } catch (err) {
      console.error('[GU3] Cart update error:', err);
    }
  }

  async function getCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  function updateNavCartCount(count) {
    const btn = document.getElementById('cartBtn');
    if (!btn) return;
    btn.setAttribute('aria-label', `Cart, ${count} items`);
    let badge = document.getElementById('cartCount');
    if (count > 0) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'nav-cart-count';
        badge.id = 'cartCount';
        btn.appendChild(badge);
      }
      badge.textContent = count;
    } else if (badge) {
      badge.remove();
    }
  }

  if (cartBtn)      cartBtn.addEventListener('click', () => cartOpen ? closeCart() : openCart());
  if (cartClose)    cartClose.addEventListener('click', closeCart);
  if (cartBackdrop) cartBackdrop.addEventListener('click', closeCart);

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-variant-id]');
    if (!btn || btn.disabled) return;
    const variantId = parseInt(btn.dataset.variantId, 10);
    if (!variantId) return;
    const originalText = btn.textContent;
    btn.textContent = 'Adding…';
    btn.disabled = true;
    addToCart(variantId)
      .then(() => {
        btn.textContent = 'Added!';
        openCart();
        setTimeout(() => {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 1500);
      })
      .catch((err) => {
        console.error('[GU3] Add to cart error:', err);
        btn.textContent = originalText;
        btn.disabled = false;
      });
  });

  /* ── PRODUCT GRIDS: tap-to-preview + quick add ────────────────────── */
  const isTouchDevice = window.matchMedia('(hover: none)').matches;
  const productCards = document.querySelectorAll('[data-product-card]');

  /* ── PRODUCT CARDS: pop into frame on scroll ───────────────────────
     Cards are visible by default; JS only opts them into the hidden
     "pending" state once it knows it can actually reveal them again. */
  if (productCards.length && 'IntersectionObserver' in window && !prefersReducedMotion) {
    productCards.forEach((card) => card.classList.add('reveal-pending'));
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.remove('reveal-pending');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    productCards.forEach((card) => revealObserver.observe(card));
  }

  function resetOtherCards(exceptCard) {
    productCards.forEach((c) => {
      if (c !== exceptCard) c.classList.remove('showing-back', 'tap-armed');
    });
  }

  if (isTouchDevice && productCards.length) {
    /* Finger passing over a card (whether scrolling the page or swiping
       the card itself) previews its back image — this never counts as a
       tap, so navigation always still takes exactly two real taps. */
    document.addEventListener('touchmove', (e) => {
      const touch = e.touches[0];
      if (!touch) return;
      const el = document.elementFromPoint(touch.clientX, touch.clientY);
      const card = el && el.closest('[data-product-card]');
      if (card && card.querySelector('.product-image--back') && !card.classList.contains('showing-back')) {
        resetOtherCards(card);
        card.classList.add('showing-back');
      }
    }, { passive: true });
  }

  document.querySelectorAll('[data-product-link]').forEach((link) => {
    link.addEventListener('click', (e) => {
      if (!isTouchDevice) return;
      const card = link.closest('[data-product-card]');
      const backImg = card && card.querySelector('.product-image--back');
      if (!backImg) return;
      if (card.classList.contains('tap-armed')) return;
      e.preventDefault();
      resetOtherCards(card);
      card.classList.add('showing-back', 'tap-armed');
    });
  });

  const quickaddSheet    = document.getElementById('quickAddSheet');
  const quickaddBackdrop = document.getElementById('quickAddBackdrop');
  const quickaddTitle    = document.getElementById('quickAddTitle');
  const quickaddPrice    = document.getElementById('quickAddPrice');
  const quickaddSizes    = document.getElementById('quickAddSizes');
  const quickaddClose    = document.getElementById('quickAddClose');
  let quickaddOpen = false;

  function openQuickAdd(handle) {
    const data = window.GU3Quickadd && window.GU3Quickadd[handle];
    if (!data || !quickaddSheet) return;

    quickaddTitle.textContent = data.title;
    quickaddPrice.textContent = data.price;
    quickaddSizes.innerHTML = '';

    data.variants.forEach((variant) => {
      const btn = document.createElement('button');
      btn.className = 'quickadd-size-btn' + (variant.available ? '' : ' sold-out');
      btn.textContent = variant.title;
      if (variant.available) {
        btn.dataset.variantId = variant.id;
        btn.addEventListener('click', closeQuickAdd);
      } else {
        btn.disabled = true;
        btn.title = 'Sold out';
      }
      quickaddSizes.appendChild(btn);
    });

    quickaddSheet.classList.add('open');
    if (quickaddBackdrop) quickaddBackdrop.classList.add('open');
    document.body.classList.add('quickadd-open');
    quickaddOpen = true;
    updateOverlayLock();
  }

  function closeQuickAdd() {
    if (!quickaddSheet) return;
    quickaddSheet.classList.remove('open');
    if (quickaddBackdrop) quickaddBackdrop.classList.remove('open');
    document.body.classList.remove('quickadd-open');
    quickaddOpen = false;
    updateOverlayLock();
  }

  document.querySelectorAll('[data-quickadd]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      openQuickAdd(btn.dataset.handle);
    });
  });

  if (quickaddClose)    quickaddClose.addEventListener('click', closeQuickAdd);
  if (quickaddBackdrop) quickaddBackdrop.addEventListener('click', closeQuickAdd);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      if (cartOpen)         closeCart();
      else if (looksOpen)   closeLooks();
      else if (searchOpen)  closeSearch();
      else if (menuOpen)    closeMenu();
      else if (quickaddOpen) closeQuickAdd();
    }
  });

})();